import React from "react";
import { Card, Stack, CardHeader, Typography } from "@mui/material";

export default function CustomList({ data = {}, variant = "elevation" }) {
  const { title, value, unit, children } = data;

  return (
    <Card variant={variant} sx={{ bgcolor: "transparent", minWidth: 280, flex: 1 }}>
      <CardHeader
        title={
          <Typography
            pl={1}
            variant="caption"
            borderLeft="3px solid"
            color="text.secondary"
            borderColor="primary.main"
          >
            {title}
          </Typography>
        }
        action={
          <Stack direction="row" alignItems="center">
            {typeof value === "string" ? (
              <Typography variant="subtitle2" fontSize={16}>
                {value}
              </Typography>
            ) : (
              value
            )}
            {unit && (
              <Typography
                width={40}
                fontSize={10}
                align="center"
                component="span"
                variant="caption"
                color="text.secondary"
              >
                {unit}
              </Typography>
            )}
          </Stack>
        }
      />
      {children && (
        <Stack pt={2} p={1} rowGap={1}>
          {children.map(({ title, value, unit }, i) => (
            <Card key={i} sx={{ borderRadius: 1, bgcolor: "action.hover" }}>
              <CardHeader
                sx={{ p: 1 }}
                title={
                  <Typography variant="caption" color="text.secondary">
                    {title}
                  </Typography>
                }
                action={
                  <Stack direction="row" alignItems="center">
                    <Typography variant="subtitle2" fontSize={14}>
                      {value}
                    </Typography>
                    {unit && (
                      <Typography
                        width={40}
                        fontSize={10}
                        align="center"
                        component="span"
                        variant="caption"
                        color="text.secondary"
                      >
                        {unit}
                      </Typography>
                    )}
                  </Stack>
                }
              />
            </Card>
          ))}
        </Stack>
      )}
    </Card>
  );
}
